import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const INVOZIO_EMPLOYER = {
  company: 'Invozio LV SIA',
  organisationNumber: '5020854062',
  address: 'Ahtri 12',
  zipCode: '10151',
  country: 'Estonia',
  phoneNumber: '010-264 88 10',
};

interface InfoFieldProps {
  label: string;
  value: string;
}

const InfoField: React.FC<InfoFieldProps> = ({ label, value }) => (
  <div className="ec-field-group">
    <label className="ec-field-label">{label}</label>
    <input className="ec-field-input" value={value} disabled readOnly />
  </div>
);

export const EmployerInfoSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="ec-section-card">
      <div className="ec-section-head">
        <span className="ec-section-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M3 21h18M5 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16M15 21V9h2a2 2 0 0 1 2 2v10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 7h3M8 11h3M8 15h3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </span>
        <h3 className="ec-section-title">{t('EMPLOYER_INFORMATION') || 'Employer Information'}</h3>
      </div>
      <Row>
        <Col md={4}>
          <InfoField label={t('COMPANY') || 'Company'} value={INVOZIO_EMPLOYER.company} />
        </Col>
        <Col md={4}>
          <InfoField label={t('ORGANISATION_NUMBER') || 'Organisation Number'} value={INVOZIO_EMPLOYER.organisationNumber} />
        </Col>
        <Col md={4}>
          <InfoField label={t('ADDRESS') || 'Address'} value={INVOZIO_EMPLOYER.address} />
        </Col>
        <Col md={4}>
          <InfoField label={t('ZIP_CODE') || 'ZIP Code'} value={INVOZIO_EMPLOYER.zipCode} />
        </Col>
        <Col md={4}>
          <InfoField label={t('COUNTRY') || 'Country'} value={INVOZIO_EMPLOYER.country} />
        </Col>
        <Col md={4}>
          <InfoField label={t('PHONE_NUMBER') || 'Phone Number'} value={INVOZIO_EMPLOYER.phoneNumber} />
        </Col>
      </Row>
    </div>
  );
};
